import Careers from 'routes/Careers'

export default Careers
